import { captureException } from '@sentry/react';
import { logOutUser } from 'api';
import { removeCookie } from 'utils/tokens';

/**
 * Signs the user out. The local session (auth cookie + user store) is always cleared, even when
 * the logout request fails: a rejected request used to skip the cleanup and leave the user signed
 * in on the dashboard, believing they had signed out (BIZ-2579). The failure is still reported.
 * Never throws, so the caller's redirect after it always runs.
 */
export const signOut = async (userId: number | undefined, clearUser: () => void): Promise<void> => {
    try {
        if (userId) {
            await logOutUser(userId);
        }
    } catch (error) {
        captureException(error, { tags: { component: 'signOut' } });
    } finally {
        removeCookie();
        clearUser();
    }
};
